module.exports = __webpack_public_path__ + "img/03.46c96a02.png";